<div class="deal-report-container">
  <div class="deal-report-header">
    <button class="back-button" (click)="goBack()">
      ← {{ backText }}
    </button>
    <h1>{{ titleText }} {{ dealId | docNo:'D' }}</h1>
  </div>

  <div *ngIf="loading" class="loading">{{ loadingText }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="generating" class="loading">{{ generatingMessage || loadingText }}</div>

  <div *ngIf="!loading && !error" #reportContent class="report-card">
    <div class="card-title-row" *ngIf="report">
      <div class="card-actions">
        <button *ngIf="isCargoOwner && canGenerateReport" class="btn-outline" type="button" (click)="generateReport()" [disabled]="generating">
          {{ regenerateReportText }}
        </button>
        <button class="btn-outline" type="button" (click)="downloadPdf()">
          {{ downloadPdfText }}
        </button>
      </div>
    </div>

    <div *ngIf="!report" class="report-empty">
      <p *ngIf="isCargoOwner && canGenerateReport">{{ reportGenerationHintText }}</p>
      <p *ngIf="isCargoOwner && !canGenerateReport">{{ reportNotAvailableUntilDeliveredText }}</p>
      <p *ngIf="!isCargoOwner">{{ reportEmptyForViewerText }}</p>
      <button *ngIf="isCargoOwner && canGenerateReport" type="button" class="btn-submit" (click)="generateReport()" [disabled]="generating">
        {{ generating ? loadingText : generateReportText }}
      </button>
    </div>

    <div *ngIf="report" class="report-content">
      <h4 *ngIf="displayTitle" class="report-title">{{ displayTitle }}</h4>

      <div *ngIf="report.content && report.content.rating != null" class="report-section">
        <strong>{{ reportRatingText }}:</strong> {{ report.content.rating }}/5
      </div>

      <div *ngIf="report.content && (report.content.generalInfoRu || report.content.generalInfoEn)" class="report-section">
        <strong>{{ reportGeneralInfoText }}:</strong>
        <p class="report-text">
          {{ (languageService.getCurrentLanguageValue() === 'en'
                ? (report.content.generalInfoEn || report.content.generalInfoRu)
                : (report.content.generalInfoRu || report.content.generalInfoEn)) }}
        </p>
      </div>

      <div *ngIf="report.content && report.content.timeline && report.content.timeline.length" class="report-section">
        <strong>{{ reportTimelineText }}:</strong>
        <ul class="report-timeline">
          <li *ngFor="let item of report.content.timeline">
            <span *ngIf="item.stageRu || item.stageEn" class="timeline-stage">
              {{ languageService.getCurrentLanguageValue() === 'en'
                  ? (item.stageEn || item.stageRu)
                  : (item.stageRu || item.stageEn) }}
            </span>
            <span *ngIf="item.dateTime" class="timeline-date">{{ item.dateTime }}</span>
            <span *ngIf="item.commentRu || item.commentEn" class="timeline-comment">
              {{ languageService.getCurrentLanguageValue() === 'en'
                  ? (item.commentEn || item.commentRu)
                  : (item.commentRu || item.commentEn) }}
            </span>
          </li>
        </ul>
      </div>

      <div *ngIf="report.content && ((report.content.prosRu && report.content.prosRu.length) || (report.content.prosEn && report.content.prosEn.length))" class="report-section">
        <strong>{{ reportProsText }}:</strong>
        <ul>
          <li *ngFor="let p of (languageService.getCurrentLanguageValue() === 'en'
                                 ? (report.content.prosEn || report.content.prosRu || [])
                                 : (report.content.prosRu || report.content.prosEn || []))">
            {{ p }}
          </li>
        </ul>
      </div>

      <div *ngIf="report.content && ((report.content.consRu && report.content.consRu.length) || (report.content.consEn && report.content.consEn.length))" class="report-section">
        <strong>{{ reportConsText }}:</strong>
        <ul>
          <li *ngFor="let c of (languageService.getCurrentLanguageValue() === 'en'
                                 ? (report.content.consEn || report.content.consRu || [])
                                 : (report.content.consRu || report.content.consEn || []))">
            {{ c }}
          </li>
        </ul>
      </div>

      <div *ngIf="report.content && (report.content.conclusionRu || report.content.conclusionEn)" class="report-section">
        <strong>{{ reportConclusionText }}:</strong>
        <p class="report-text">
          {{ (languageService.getCurrentLanguageValue() === 'en'
                ? (report.content.conclusionEn || report.content.conclusionRu)
                : (report.content.conclusionRu || report.content.conclusionEn)) }}
        </p>
      </div>
    </div>
  </div>
</div>
